<script lang="ts">
  import { getContext, type Snippet } from 'svelte'

  type Props = {
    children: Snippet
    variant?: 'default' | 'destructive'
    href?: string
    onclick?: () => void
  }

  const { children, href, onclick, variant = 'default' }: Props = $props()
  const dropdownContext = getContext<DropdownContext>('dropdownContext')

  function handleClick() {
    onclick?.()
    dropdownContext.isOpen = false
  }
</script>

{#if href}
  <a
    class={['container', variant]}
    {href}
    onclick={handleClick}
    onauxclick={handleClick}
  >
    {@render children()}
  </a>
{:else}
  <button class={['container', variant]} onclick={handleClick}>
    {@render children()}
  </button>
{/if}

<style lang="scss">
  .container {
    background: var(--dropdown-background);
    border: 0;
    border-bottom: 1px solid var(--dropdown-stroke);
    color: var(--dropdown-foreground);
    cursor: pointer;
    font-size: 0.75rem;
    max-width: 16rem;
    overflow: hidden;
    padding: 0.5rem 1rem;
    text-align: start;
    text-decoration: none;
    text-overflow: ellipsis;
    transition: background 0.3s ease;
    white-space: nowrap;
    border-radius: 0 !important;

    &:hover {
      background: var(--dropdown-background-hover);
    }

    &:last-of-type {
      border-bottom: none;
    }

    &.destructive :global {
      color: var(--red);
    }
  }
</style>
